<template>
  <!-- 商户信息管理，用于通联支付对接 -->
  <div style="height: 100%">
    <list-page v-if="dataLevel === 1" :show-shadow="false">
      <search-condition @search="resetSearch" :show-shadow="false">
        <template #default>
          <date-range v-model:start-time="searchInfo.startTime" v-model:end-time="searchInfo.endTime"  class="double-width">
            <template #prefix>考勤时间</template>
          </date-range>
          <el-select v-model="searchInfo.projectId" placeholder="请选择项目" clearable>
            <template #prefix>项目</template>
            <el-option v-for="item in projectList" :key="item.id" :value="item.id" :label="item.projectName"></el-option>
          </el-select>
          <el-select v-model="searchInfo.siteId" placeholder="请选择工地" clearable>
            <template #prefix>工地</template>
            <el-option v-for="item in siteList" :key="item.id" :value="item.id" :label="item.siteName"></el-option>
          </el-select>
          <el-select v-model="searchInfo.classmateId" placeholder="请选择班组" clearable>
            <template #prefix>班组</template>
            <el-option v-for="item in classmateList" :key="item.id" :value="item.id" :label="item.classmateName"></el-option>
          </el-select>
          <el-select v-model="searchInfo.lot" placeholder="请选择班组标段" clearable>
            <template #prefix>班组标段</template>
            <el-option v-for="item in lotList" :key="item.id" :value="item.dictCode" :label="item.dictName"/>
          </el-select>
        </template>
        <template #option>
          <page-button hasPerm="laborers:attendance:query" el-type="primary" @click="resetSearch">查询</page-button>
          <page-button hasperm="laborers:attendance:export" el-type="success" @click="toExport">导出</page-button>
          <!--          <page-button hasPerm="laborers:attendance:query" el-type="primary" @click="$router.push('/laborers/attendance/video')">考勤视频</page-button>-->
        </template>
      </search-condition>
      <list-table :show-shadow="false">
        <laborers-attendance-other-data :data-list="dataList" :level="dataLevel" @toDetail="toDetail2"/>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
    <list-page v-else-if="dataLevel === 2" :show-shadow="false">
      <laborers-attendance-label :data="currentData2" :level="dataLevel" @back2List="dataLevel = 1"/>
      <list-table :show-shadow="false">
        <laborers-attendance-other-data :data-list="dataList2" :level="dataLevel" @toDetail="toDetail3" :current-data="currentData2"/>
      </list-table>
      <form-page v-model:page-number="searchInfo2.pageNumber" v-model:page-size="searchInfo2.pageSize"
                 :total-count="searchInfo2.totalCount" @onLoad="queryList2"/>
    </list-page>
    <list-page v-else-if="dataLevel === 3" :show-shadow="false">
      <laborers-attendance-label :data="currentData3" :level="dataLevel" @back2List="dataLevel = 2"/>
      <list-table :show-shadow="false">
        <laborers-attendance-other-data :data-list="dataList3" :level="dataLevel" @toDetail="toDetail" :current-data="currentData3"/>
      </list-table>
      <form-page v-model:page-number="searchInfo3.pageNumber" v-model:page-size="searchInfo3.pageSize"
                 :total-count="searchInfo3.totalCount" @onLoad="queryList3"/>
    </list-page>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import {useRoute, useRouter} from "vue-router";
import attendanceApi from "@/api/dz-luqiao/attendanceApi";
import Util from "@/util/util";
import LaborersAttendanceOtherData from "@/views/h5/luqiao/laborers/attendance/result/LaborersAttendanceOtherData.vue";
import LaborersAttendanceLabel from "@/views/h5/luqiao/laborers/attendance/result/LaborersAttendanceLabel.vue";
import DateRange from "@/components/h5/date/YqDateRange.vue";
import excelUtil from "@/util/excelUtil";

export default {
  props: {
    type: {default: ""},
    projectList: {default: () => []}, // 项目列表
    siteList: {default: () => []},
    classmateList: {default: () => []},
    lotList: {default: () => []},
    checkName: {default: ""},
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "LA",
  components: {
    DateRange,
    SearchCondition,
    FormPage,
    ListTable,
    ListPage, LaborersAttendanceOtherData, LaborersAttendanceLabel
  },
  data() {
    return {
      dataLevel: 1,
      searchInfo: {},
      dataList: [],
      searchInfo2: {},
      dataList2: [],
      currentData2: {},
      searchInfo3: {},
      dataList3: [],
      currentData3: {},
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  async created() {
    // 时间是今天
    this.searchInfo.checkType = this.type;
    this.searchInfo.startTime = new Date(new Date().getTime()).format("yyyy-MM-dd") + " 00:00:00";
    this.searchInfo.endTime = new Date().format("yyyy-MM-dd") + " 23:59:59";
    this.resetSearch();
  },
  methods: {
    async queryList() {
      if (this.dataLevel === 1) {
        let param = {
          ...this.searchInfo,
          searchType: 1,
        }
        // 1级页面，查询
        const {records, totalCount} = await attendanceApi.list(param)
        this.getInfo(records);
        this.dataList = records;
        this.searchInfo.totalCount = totalCount;
      }
    },
    getInfo(list) {
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < this.lotList.length; j++) {
          if (this.lotList[j].dictCode === list[i].lot) {
            list[i].lotName = this.lotList[j].dictName;
          }
        }
      }
    },
    toExport() {
      let p = {...this.searchInfo, checkType: this.type, checkName: this.checkName};
      excelUtil.exportExcel("/luqiao/attendance/excelExportWorkersOther", p, "考勤数据");
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    toDetail(data) {
      if (this.level === '1') {
        this.router.push(`/laborers/attendance/otherDetail?pid=${data.projectId}&sid=${data.siteId}&cid=${data.classmateId}&date=${data.attendanceDate.split(" ")[0]}&level=2&type=${this.type || this.route.query.type}`)
      } else if (this.level === '2') {
        this.router.push(`/laborers/attendance/detail?sid=${data.siteId}&cid=${data.classmateId}&date=${this.route.query.date}&workerId=${data.workersId}&checkType=${this.type || this.route.query.type}`)
      }
    },
    // 到二级页面
    toDetail2(data) {
      if (data.resultTotal === 0) {
        this.$message.error("当前施工班组没有对应的劳务人员");
        return;
      }
      this.searchInfo2 = {
        projectId: data.projectId,
        siteId: data.siteId,
        classmateId: data.classmateId,
        attendanceDate: data.attendanceDate.substring(0, 10),
        checkType: this.type,
        searchType: 2
      }
      this.currentData2 = data;
      this.dataLevel = 2;
      this.resetSearch2();
    },
    resetSearch2() {
      this.searchInfo2.pageNumber = 1;
      this.queryList2();
    },
    queryList2() {

      attendanceApi.list(this.searchInfo2).then(res => {
        // 添加标段信息
        res.records.forEach(item => {
          item.lotName = this.lotList.find(lot => lot.dictCode === item.lot)?.dictName;
        })
        this.dataList2 = res.records;
        this.searchInfo2.totalCount = res.totalCount;
      })
    },
    // 到三级页面
    toDetail3(data) {
      this.searchInfo3 = {
        projectId: data.projectId,
        siteId: data.siteId,
        workerId: data.workersId,
        attendanceDate: this.currentData2.attendanceDate.substring(0, 10),
        classmateId: data.classmateId,
        checkType: this.type,
      }
      this.currentData3 = data;
      this.dataLevel = 3;
      this.resetSearch3();
    },
    resetSearch3() {
      this.searchInfo3.pageNumber = 1;
      this.queryList3();
    },
    queryList3() {
      attendanceApi.queryListDetail(this.searchInfo3).then(res => {
        this.dataList3 = res.records;
        this.searchInfo3.totalCount = res.totalCount;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.error-status{
  color: var(--el-color-danger);
}
</style>